import React, { useState, useEffect } from "react";
import T from "../styles/tokens";
import { Badge, Spinner, fmtDateTime } from "../components/UI";
import * as api from "../utils/api";

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.getAuditLog({ limit: 200 }).then(setEntries).catch(console.error).finally(() => setLoading(false));
  }, []);

  const filtered = filter === "all" ? entries : entries.filter((e) => e.severity === filter);

  if (loading) return <div style={{ display: "flex", justifyContent: "center", paddingTop: 80 }}><Spinner size={36} /></div>;

  return (
    <div style={{ animation: "pfFadeIn 0.3s ease-out" }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: T.indigo, fontFamily: T.font, margin: "0 0 6px" }}>Audit Log</h1>
      <p style={{ fontSize: 13, color: T.gray400, fontFamily: T.font, marginBottom: 24 }}>{entries.length} total events</p>

      {/* Severity filters */}
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {["all", "info", "warning", "critical"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: "6px 14px", borderRadius: 99, border: "none", cursor: "pointer",
              fontSize: 12, fontWeight: 600, fontFamily: T.font,
              background: filter === f ? T.purple : T.white,
              color: filter === f ? T.white : T.charcoal,
              transition: "all 0.15s",
            }}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {/* Entries */}
      <div style={{ background: T.white, borderRadius: T.radius, border: `1px solid ${T.gray200}` }}>
        {filtered.map((e, i) => (
          <div
            key={e.id}
            style={{
              display: "grid", gridTemplateColumns: "100px 110px 1fr 160px",
              alignItems: "center", gap: 12,
              padding: "12px 20px",
              borderBottom: i < filtered.length - 1 ? `1px solid ${T.gray100}` : "none",
              fontSize: 13, fontFamily: T.font,
            }}
          >
            <Badge status={e.severity} />
            <span style={{ fontSize: 11, color: T.gray400, fontWeight: 500 }}>{e.clientName}</span>
            <div>
              <div style={{ color: T.charcoal }}>{e.detail}</div>
              <div style={{ fontSize: 11, color: T.gray400, marginTop: 2 }}>{e.actor}</div>
            </div>
            <span style={{ fontSize: 11, color: T.gray400, textAlign: "right" }}>{fmtDateTime(e.timestamp)}</span>
          </div>
        ))}
        {filtered.length === 0 && (
          <div style={{ padding: 32, textAlign: "center", color: T.gray400, fontStyle: "italic" }}>No audit events match this filter.</div>
        )}
      </div>
    </div>
  );
}
